export default __webpack_public_path__ + "static/media/Sash of the Blood God.16c1ee92.jpg";